module.exports = __webpack_public_path__ + "img/Card-Moats-HiRes.8905452d.png";